import React from 'react'

export default function Spacing() {

  return (<div className="spacing" style={{ height: 140 }}></div>)

}
